import React from 'react'
import useActionHook from '../../hooks/useActionHook';
import TypoCss from "./typography.module.scss";



function Hyperlink(props) {
    const {before, a, after} = props;

  return (
    <p className={TypoCss.tbx_p1}>
      {before}{" "}
      <a className={TypoCss.tabclix__a} onClick={useActionHook(props)}>
        {a}
      </a>{" "}
      {after}
    </p>
  );
}

export default Hyperlink;